import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import type { Granularity } from '../hooks/use-daily-input-data'

dayjs.extend(isoWeek)

/** Format X-axis tick label based on granularity */
export const formatXAxis = (
    value: string,
    granularity: Granularity
): string => {
    switch (granularity) {
        case 'week': {
            const [year, weekStr] = value.split('-W')
            const startOfWeek = dayjs()
                .year(parseInt(year, 10))
                .isoWeek(parseInt(weekStr, 10))
                .startOf('isoWeek')
            return `${startOfWeek.format('DD')}-${startOfWeek.endOf('isoWeek').format('DD/MM')}`
        }
        case 'month':
            return dayjs(value + '-01').format('MMM')
        default:
            return dayjs(value).format('DD/MM')
    }
}

/** Format tooltip label based on granularity */
export const formatTooltipLabel = (
    value: string,
    granularity: Granularity
): string => {
    switch (granularity) {
        case 'week': {
            const [year, weekStr] = value.split('-W')
            const startOfWeek = dayjs()
                .year(parseInt(year, 10))
                .isoWeek(parseInt(weekStr, 10))
                .startOf('isoWeek')
            return `${startOfWeek.format('DD/MM')} - ${startOfWeek.endOf('isoWeek').format('DD/MM/YYYY')}`
        }
        case 'month':
            return dayjs(value + '-01').format('MMMM YYYY')
        default:
            return dayjs(value).format('DD/MM/YYYY')
    }
}

/** Export chart ref element to PDF */
export const exportChartToPDF = async (
    chartEl: HTMLDivElement,
    employeeName: string | null,
    dateRange: { gte?: string; lte?: string }
) => {
    const canvas = await html2canvas(chartEl, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
    })

    const imgData = canvas.toDataURL('image/jpeg', 0.92)
    const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4',
        compress: true,
    })

    const imgWidth = 287
    const imgHeight = (canvas.height * imgWidth) / canvas.width
    pdf.addImage(imgData, 'JPEG', 5, 5, imgWidth, imgHeight, '', 'FAST')

    let filename = 'daily_input'
    if (employeeName) {
        const sanitized = employeeName
            .replace(/\s+/g, '_')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
        filename = `daily_input_${sanitized}`
    }
    filename += `_${dateRange.gte}_${dateRange.lte}.pdf`
    pdf.save(filename)
}
